<app-header></app-header>
<div class="container-fluid">
    <div class="row main-card-style">
      <mat-tab-group mat-align-tabs="start">
        <!-- <mat-tab label="Scheduler"><app-assign-scheduler></app-assign-scheduler></mat-tab> -->
        <mat-tab label="Nurse Practitioner"><app-assign-nurse-practitioner></app-assign-nurse-practitioner></mat-tab>
        <!-- <mat-tab label="Coder"><app-assign-coder></app-assign-coder></mat-tab> -->
      </mat-tab-group>
    </div>
  </div>
<app-footer></app-footer>